var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_886_11471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21875 14.5313C9.21875 14.9628 9.56852 15.3125 10 15.3125C10.4315 15.3125 10.7813 14.9628 10.7813 14.5313C10.7813 14.0998 10.4315 13.75 10 13.75C9.56852 13.75 9.21875 14.0998 9.21875 14.5313ZM10 4.6875C10.4315 4.6875 10.7813 5.03727 10.7813 5.46875V11.4062C10.7813 11.8377 10.4315 12.1875 10 12.1875C9.56852 12.1875 9.21875 11.8377 9.21875 11.4062V5.46875C9.21875 5.03727 9.56852 4.6875 10 4.6875ZM0.0426197 18.9668C-0.164919 19.5791 0.421251 20.1648 1.03328 19.9575L4.9486 18.6302C6.47731 19.5268 8.21574 19.9988 10.0006 19.9988C15.5277 19.9988 20 15.5257 20 9.99937C20 4.47227 15.527 0 10.0006 0C4.47356 0 0.00125313 4.47305 0.00125313 9.99937C0.00125313 11.7843 0.473282 13.5227 1.36981 15.0514L0.0426197 18.9668ZM2.88543 14.5352C2.02074 13.1818 1.56367 11.6133 1.56367 9.99937C1.56367 5.33586 5.33778 1.56238 10.0006 1.56238C14.6641 1.56238 18.4376 5.33648 18.4376 9.99937C18.4376 14.6629 14.6635 18.4364 10.0006 18.4364C8.38668 18.4364 6.81824 17.9793 5.46484 17.1146C5.265 16.9869 5.01801 16.9569 4.79344 17.033L2.03032 17.9697L2.96696 15.2066C3.04309 14.982 3.01309 14.735 2.88543 14.5352Z",
    fill: "#58595B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_886_11471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.eb4911c697ecb73b71256a62072c3afc.svg";
export { ForwardRef as ReactComponent };